import { render, staticRenderFns } from "./OrderTemplateDialog.vue?vue&type=template&id=b0d897f4&scoped=true&"
import script from "./OrderTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./OrderTemplateDialog.vue?vue&type=script&lang=js&"
import style0 from "./OrderTemplateDialog.vue?vue&type=style&index=0&id=b0d897f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d897f4",
  null
  
)

/* custom blocks */
import block0 from "./OrderTemplateDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports